/**
 * Convert hex color to rgba string
 * @param hex - Hex color (e.g., '#ffff00' or 'ffff00')
 * @param alpha - Alpha value (0-1)
 * @returns rgba string (e.g., 'rgba(255,255,0,0.95)')
 */
export function hexToRgba(hex: string, alpha: number = 1): string {
  // Remove # if present
  const cleanHex = hex.replace('#', '');
  
  // Parse RGB values
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  
  return `rgba(${r},${g},${b},${alpha})`;
}

/**
 * Convert hex color to rgb string
 */
export function hexToRgb(hex: string): string {
  const cleanHex = hex.replace('#', '');
  const r = parseInt(cleanHex.substring(0, 2), 16);
  const g = parseInt(cleanHex.substring(2, 4), 16);
  const b = parseInt(cleanHex.substring(4, 6), 16);
  return `rgb(${r},${g},${b})`;
}

